export default __webpack_public_path__ + "static/media/ha_fillers.c1e1643b.pdf";